module.exports = __webpack_public_path__ + "static/media/backgroup1.df1e348e.png";